import { render, staticRenderFns } from "./SelectPaymentType.vue?vue&type=template&id=24d2b61c"
import script from "./SelectPaymentType.vue?vue&type=script&lang=js"
export * from "./SelectPaymentType.vue?vue&type=script&lang=js"
import style0 from "./SelectPaymentType.vue?vue&type=style&index=0&id=24d2b61c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports